import Vue3VideoPlayer from '@cloudgeek/vue3-video-player';
import Antd from 'ant-design-vue';
import { provideRouter } from 'src/utils/router-bridge';
import { provideStore } from 'src/utils/store-bridge';
import toast from 'src/utils/toast';
import { createApp } from 'vue';
import VueFlatPickr from 'vue-flatpickr-component';
import Vue3Tour from 'vue3-tour';
import App from './App.vue';
import CustomIcon from './components/shared/Components/CustomIcon.vue';
import clickOutside from './directives/clickOutside';
import VueTourSetup from './plugins/vue-tour-setup';
import router from './router/index';
import store from './store/index';

import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css';
import 'ant-design-vue/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'flatpickr/dist/flatpickr.css';
import contextmenu from 'v-contextmenu';
import 'v-contextmenu/dist/themes/default.css';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import 'vue3-circle-progress/dist/circle-progress.css';
import vue3GoogleLogin from 'vue3-google-login';
import VueKonva from 'vue3-konva';
import VOtpInput from 'vue3-otp-input';
import 'vue3-tour/dist/vue3-tour.css';
import customIcons from './config/custom-icons-config';
import firebaseMessaging from './config/firebase-config';
import cdnDirectives from './directives/cdnDirectives';

// Highcharts
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import HighchartsMore from 'highcharts/highcharts-more';
import AccessibilityModule from 'highcharts/modules/accessibility';
import BoostModule from 'highcharts/modules/boost';
import ExportDataModule from 'highcharts/modules/export-data';
import ExportingModule from 'highcharts/modules/exporting';
import SeriesLabelModule from 'highcharts/modules/series-label';
import XrangeModule from 'highcharts/modules/xrange.js';
import { emitter } from 'src/utils/emitter';
import TimelineChartConfig from './components/user-panel/pages/analytics/Charts/HighCharts';

SeriesLabelModule(Highcharts);
HighchartsMore(Highcharts);
ExportingModule(Highcharts);
ExportDataModule(Highcharts);
AccessibilityModule(Highcharts);
BoostModule(Highcharts);
XrangeModule(TimelineChartConfig);

const app = createApp(App);

const globalOptions = {
  mode: 'auto',
};
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$toast = toast;
// Provide instances to bridges before plugins use them
provideStore(store);
provideRouter(router);
app.config.globalProperties.$customIcons = customIcons;
app.config.globalProperties.$messaging = firebaseMessaging;

app.component('v-otp-input', VOtpInput);
app.use(VueTelInput, globalOptions);
app.use(store);
app.use(Vue3VideoPlayer);
app.use(Vue3Tour);
app.use(VueTourSetup);
app.use(Antd);
app.use(VueKonva);
app.use(router);
app.use(contextmenu);
app.use(VueFlatPickr);
app.use(vue3GoogleLogin, {
  clientId:
    '455253624193-252ac7kbdikr8ep53mij2oqpn2d31tn8.apps.googleusercontent.com',
});
app.provide('emitter', emitter);
app.provide('toast', toast);
// app.use(Markdown);
app.component('CustomIcon', CustomIcon);
app.directive('click-outside', clickOutside);
app.directive('cdn', cdnDirectives);

app.use(HighchartsVue);
app.mount('#app');
